export default "__VITE_ASSET__CSaa8YJY__";